module.exports = __webpack_public_path__ + "img/rightTop.d837761f.png";